import React, { Component } from "react";
import { connect } from "react-redux";

import ProjectQaWeldingInspectionForm from "./form";
import { updateProjectQaWeldingInspection, getProjectQaWeldingInspection, destroyProjectQaWeldingInspection } from "../actions";

import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";

import { Page, Navbar } from "framework7-react";

// Helpers
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

function mapStateToProps(state, ownProps) {
  const {
    f7route: {
      params: { id },
    },
  } = ownProps;

  return {
    current_user: state.current_user,
    project_qa_welding_inspection: state.project_qa_welding_inspections[id],
  };
}

class EditProjectQaWeldingInspection extends Component {
  constructor(props) {
    super(props);

    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    const updateRole = HasRole(
      {
        resource_type: "Project::Qa::WeldingInspection",
        name: ["update", "moderator"],
      },
      true
    );

    const { project_id, id } = this.props;

    if (updateRole) {
      this.props.getProjectQaWeldingInspection(project_id, id);
    }

    const returnUrl = `/project/qa/welding_inspections`;

    this.state = {
      returnUrl: returnUrl,
      updateRole,
    };
  }
  submitForm(values) {
    const {
      f7router: { app },
      project_id,
      id,
    } = this.props;

    this.preloader = app.preloader;
    this.preloader.show();
    const updateRequest = this.props.updateProjectQaWeldingInspection(project_id, id, values, false);
    updateRequest.then(this.successfullySubmitted);
  }

  successfullySubmitted() {
    const {
      f7router,

      f7router: { app, navigate },
    } = this.props;

    const { returnUrl } = this.state;

    this.preloader.hide();
    app.toast
      .create({
        icon: '<i class="material-icons">check</i>',
        text: "Updated Welding Inspection!",
        position: "center",
        closeTimeout: 2000,
        on: {
          opened: () => {
            f7router.navigate(returnUrl);
          },
        },
      })
      .open();
  }

  render() {
    const {
      project_qa_welding_inspection,
      history,
      current_user: { admin, roles },
      f7route: {
        params: { project_id },
      },
    } = this.props;
    const { returnUrl, updateRole } = this.state;

    if (!updateRole) {
      return <NotAuthorized />;
    }
    return (
      <Page>
        <Navbar title="Update Welding Inspection" backLink />
        {_.isNotEmpty(project_qa_welding_inspection) && (
          <Form
            component={ProjectQaWeldingInspectionForm}
            onSubmit={this.submitForm}
            formLabel="Update"
            edit
            mutators={{
              ...arrayMutators,
            }}
            project_id={project_id}
            initialValues={project_qa_welding_inspection}
            cancelFunction={() => {
              history.push(returnUrl);
            }}
            {...this.props}
          />
        )}
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  getProjectQaWeldingInspection,
  updateProjectQaWeldingInspection,
  destroyProjectQaWeldingInspection,
})(EditProjectQaWeldingInspection);
